import { z } from 'zod';


export const costCenterFormBaseSchema = z.object({
  code: z
    .string()
    .min(1, 'organization:validation.costCenterCodeRequired')
    .max(50, 'organization:validation.costCenterCodeMaxLength'),
  name: z
    .string()
    .min(1, 'organization:validation.costCenterNameRequired')
    .max(100, 'organization:validation.costCenterNameMaxLength'),
  description: z
    .string()
    .min(1, 'organization:validation.costCenterDescriptionRequired')
    .max(8000, 'organization:validation.costCenterDescriptionMaxLength'),
});

export const createCostCenterSchema = costCenterFormBaseSchema;

export type CostCenterFormData = z.infer<typeof costCenterFormBaseSchema>;
export type CreateCostCenterFormData = CostCenterFormData;
